"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const ton_core_1 = require("ton-core");
const de_ui_1 = require("@delab-team/de-ui");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const svg_selector_1 = require("../../../assets/svg-selector");
const tonapi_1 = require("../../../logic/tonapi");
const select_token_1 = require("./select-token");
const enter_amount_1 = require("./enter-amount");
const invoice_1 = require("./invoice");
const pay_1 = require("./pay");
const modal_1 = require("../../../components/ui/modal");
// import { buyData } from '../../../mocks/buy-data'
const buy_modal_module_css_1 = __importDefault(require("./buy-modal.module.css"));
const BuyModal = (props) => {
    const TgObj = sdk_1.default;
    const tonapi = new tonapi_1.TonApi();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [success, setSuccess] = (0, react_1.useState)(false);
    const [apiResponce, setApiResponce] = (0, react_1.useState)(undefined);
    const [availableAmount, setAvailableAmount] = (0, react_1.useState)(undefined);
    const [rubAmount, seRubAmount] = (0, react_1.useState)(undefined);
    console.log('RUB AMOUNT', rubAmount);
    const [isSended, setIsSended] = (0, react_1.useState)(false);
    const handleBtnPay = () => {
        if (!apiResponce) {
            alert('Empty response');
            return;
        }
        if ('confirmationUrl' in apiResponce) {
            TgObj.openLink(apiResponce?.confirmationUrl);
            // window.open(props.apiResponce?.confirmationUrl, '_blank')
        }
        else if ('verificationUrl' in apiResponce) {
            // window.open(props.apiResponce?.verificationUrl, '_blank')
            TgObj.openLink(apiResponce?.verificationUrl);
        }
    };
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        props.setShowBuyModal(false);
        props.setPosition(0);
        props.setSendData({
            token: '',
            tokenAddress: '',
            amount: '',
            availableBalance: ''
        });
        setIsSended(false);
        setApiResponce(undefined);
        window.document.body.style.overflow = 'auto';
        TgObj.MainButton.offClick(handleBtnPay);
        TgObj.MainButton.hide();
    };
    (0, react_1.useEffect)(() => {
        if (props.showBuyModal) {
            window.document.body.style.overflow = 'hidden';
            window.document.body.style.position = 'fixed';
            window.document.body.style.width = '100vw';
        }
        return () => {
            window.document.body.style.overflow = 'auto';
            window.document.body.style.position = 'relative';
            window.document.body.style.width = '';
        };
    }, [props.showBuyModal]);
    const handleOpenLink = (href) => {
        if (props.isTg) {
            TgObj.openLink(href);
        }
        else {
            window.open(href, '_blank');
        }
    };
    let switchText = '';
    switch (props.position) {
        case 0:
            switchText = t('send.select-token');
            break;
        case 1:
            switchText = t('send.enter-amount');
            break;
        case 2:
            switchText = t('buy-modal.create-invoice');
            break;
        case 3:
            switchText = t('buy-modal.pay-invoice');
            break;
        default:
            switchText = t('send.unknown');
            break;
    }
    const handleBack = () => {
        if (props.position === 0) {
            handleCloseModal();
        }
        else if (props.position === 1) {
            TgObj.HapticFeedback.impactOccurred('medium');
            props.setPosition(0);
            TgObj.MainButton.hide();
        }
        else if (props.position === 2) {
            TgObj.HapticFeedback.impactOccurred('medium');
            props.setPosition(1);
            TgObj.MainButton.hide();
        }
        else if (props.position === 3) {
            handleCloseModal();
        }
    };
    console.log('position', props.position);
    console.log('buy modal sendData', props.sendData);
    console.log('apiResponce', apiResponce);
    (0, react_1.useEffect)(() => {
        const getInfo = async () => {
            try {
                const priceTokenRub2 = await tonapi.getTokenPrice(props.sendData.tokenAddress, 'rub');
                if (!priceTokenRub2 || !priceTokenRub2?.rates[props.sendData.tokenAddress]?.prices.RUB || !priceTokenRub2.rates) {
                    return;
                }
                console.log('full rub amount', (priceTokenRub2.rates[props.sendData.tokenAddress].prices.RUB * Number(props.sendData.amount)));
                seRubAmount((priceTokenRub2.rates[props.sendData.tokenAddress].prices.RUB * Number(props.sendData.amount)).toFixed(0));
            }
            catch (error) {
                console.error('Error fetching token price:', error);
            }
        };
        getInfo();
    }, [props.sendData, props.sendData.tokenAddress, props.sendData.amount]);
    (0, react_1.useEffect)(() => {
        const getAvailableBalance = async () => {
            try {
                if (props.sendData.token === 'TON') {
                    const res = await tonapi.getHumanFriendlyInfo('EQBbrCXUBBQBCjj7dxS-IO0JTj51ZzQTN2FdGKQQTO_EW6bL');
                    const balance = res.balance;
                    console.log('TON balance in service', balance);
                    setAvailableAmount((0, ton_core_1.fromNano)(balance));
                }
                else if (props.sendData.token !== 'TON') {
                    const res = await tonapi.getAllJettonsBalances('EQBbrCXUBBQBCjj7dxS-IO0JTj51ZzQTN2FdGKQQTO_EW6bL');
                    console.log('res tokens', res);
                    const tokenInfo = res?.balances.find(el4 => (el4?.jetton?.address === props.sendData.tokenAddress || el4?.jetton?.symbol === props.sendData.token));
                    if ((!tokenInfo?.balance) || tokenInfo?.balance === undefined || tokenInfo === undefined || !tokenInfo) {
                        setAvailableAmount('0');
                        return;
                    }
                    console.log('getAvailableBalance', res);
                    console.log('tokenInfo', tokenInfo);
                    console.log('tokenInfo!.balance', (0, ton_core_1.fromNano)(tokenInfo.balance));
                    setAvailableAmount((0, ton_core_1.fromNano)(tokenInfo.balance));
                }
            }
            catch (err) {
                console.error(err);
            }
        };
        getAvailableBalance();
    }, [props.sendData.tokenAddress, props.sendData.token, props.sendData, props.position]);
    return ((0, jsx_runtime_1.jsx)("div", { className: buy_modal_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsxs)(modal_1.Modal, { isOpen: props.showBuyModal, onClose: handleCloseModal, isCloseButton: false, className: buy_modal_module_css_1.default.modal, children: [(0, jsx_runtime_1.jsxs)("div", { className: buy_modal_module_css_1.default.modalTop, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: buy_modal_module_css_1.default.modalTopButton, onClick: handleBack, children: [props.position !== 0 && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-left", isTg: props.isTg }), props.position === 0 ? t('common.close') : t('common.back')] }), props.position !== 0 && ((0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: buy_modal_module_css_1.default.modalTopButton, onClick: () => {
                                handleCloseModal();
                            }, children: t('common.close') }))] }), (0, jsx_runtime_1.jsxs)("div", { className: buy_modal_module_css_1.default.content, children: [props.position === 0 && ((0, jsx_runtime_1.jsx)(select_token_1.SelectToken, { sendData: props.sendData, setSendData: props.setSendData, setPosition: props.setPosition, tokensData: props.tokensData })), props.position === 1 && ((0, jsx_runtime_1.jsx)(enter_amount_1.EnterAmount, { sendData: props.sendData, setSendData: props.setSendData, position: props.position, setPosition: props.setPosition, isTg: props.isTg, availableAmount: availableAmount, rubAmount: rubAmount })), props.position === 2 && ((0, jsx_runtime_1.jsx)(invoice_1.CreateInvoice, { sendData: props.sendData, setSendData: props.setSendData, position: props.position, setPosition: props.setPosition, isTg: props.isTg, addressUser: props.addressUser, setApiResponce: setApiResponce, rubAmount: rubAmount })), props.position === 3 && ((0, jsx_runtime_1.jsx)(pay_1.PayInvoice, { sendData: props.sendData, setSendData: props.setSendData, position: props.position, setPosition: props.setPosition, isTg: props.isTg, addressUser: props.addressUser, setApiResponce: setApiResponce, apiResponce: apiResponce, setSuccess: setSuccess, handleBtnPay: handleBtnPay }))] }), props.position !== 3 && (0, jsx_runtime_1.jsx)("div", { className: buy_modal_module_css_1.default.background }), props.position === 3 && (success ? (0, jsx_runtime_1.jsx)("div", { className: buy_modal_module_css_1.default.backgroundSuccess }) : (0, jsx_runtime_1.jsx)("div", { className: buy_modal_module_css_1.default.backgroundError }))] }) }));
};
exports.BuyModal = BuyModal;
